var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgErrorIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 408.84 408.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#df4f5f;}.cls-2{fill:#e5717d;}.cls-3{fill:#e2616f;}.cls-4{fill:#ed9fa8;}.cls-5{fill:#e98590;}.cls-6{fill:#efa9b1;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.47,408.64h-2.4c-.94-1.41-2.42-.77-3.65-.89-28.84-2.71-56.26-10.45-81.28-25.08C42.28,345.89,7,291.21.72,218.41c-2.82-32.67,2.68-64.22,15.71-94.25C55.4,34.33,149.25-14.85,245.12,4c83.71,16.46,149.32,85.84,161.57,170.76.65,4.51.46,9.17,2.15,13.52v2.39c-1.16.8-.79,1.6,0,2.4v4.79a4.22,4.22,0,0,0,0,4.79v3.19a4.22,4.22,0,0,0,0,4.79v4.79c-.79.8-1.16,1.6,0,2.4V221c-1.15.5-.73,1.57-.86,2.42-1.1,7.36-1.85,14.78-3.32,22.06-17.09,84.23-86.23,148.89-171.9,161-4.92.69-10,.4-14.74,2.13h-2.4c-1.13-1.3-2.6-.61-3.94-.68l-4-.06h-6.46l-4,0C195.61,408.07,193.87,407.2,192.47,408.64ZM172.42,204.51c-.76.81-1.54,1.69-2.37,2.53q-29.62,29.64-59.31,59.22c-2.17,2.15-2.4,3.35-.08,5.6q13.2,12.76,26,26c2.28,2.35,3.51,2.48,5.89.08,19.56-19.76,39.32-39.33,58.87-59.1,2.44-2.46,3.64-2.56,6.14,0,19.55,19.78,39.31,39.34,58.87,59.1,2.37,2.4,3.6,2.3,5.88-.06q12.76-13.2,26-26c2.31-2.24,2.11-3.43-.07-5.59-19.65-19.49-39.13-39.15-58.81-58.6-2.63-2.59-3-3.9-.14-6.72,19.81-19.51,39.37-39.28,59.11-58.86,2.1-2.08,2.21-3.19,0-5.31Q285,123.83,272.11,110.52c-2.14-2.2-3.33-2.33-5.59,0C246.86,130.32,227,150,207.36,169.85c-2.38,2.41-3.55,2.27-5.85-.06C182,150,162.21,130.45,142.63,110.7c-2.22-2.23-3.45-2.72-5.88-.18-8.3,8.63-16.72,17.16-25.42,25.38-3.06,2.89-2.64,4.33.11,7,19.69,19.45,39.21,39.07,58.76,58.66C171,202.42,172.13,203,172.42,204.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M201.21,407.91h6.46c0,.24,0,.49,0,.74h-6.39C201.24,408.39,201.23,408.15,201.21,407.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M408.84,202.64a4.22,4.22,0,0,1,0-4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M408.84,210.62a4.22,4.22,0,0,1,0-4.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M192.47,408.64c1.4-1.44,3.14-.57,4.74-.69,0,.23,0,.46,0,.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M197.26,408.64c0-.23,0-.46,0-.69l4,0c0,.24,0,.48,0,.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M207.64,408.64c0-.25,0-.5,0-.74l4,.06c0,.22,0,.45-.05.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M211.63,408.64c0-.23,0-.46.05-.68,1.34.07,2.81-.62,3.94.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M408.84,193.06c-.79-.8-1.16-1.6,0-2.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M408.84,217.81c-1.16-.8-.79-1.6,0-2.4Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/errorIcon.351071af754b6ae983a2840f7dea575c.svg";
export { ForwardRef as ReactComponent };